<template>
  <div
    v-if="currentPage"
  >
    <component
      :is="template"
      :page="currentPage"
    />
  </div>
</template>

<script setup lang="ts">
import Default from '~/components/templates/Default.vue';
import IntroImage from '~/components/templates/IntroImage.vue';
import IntroSmallImage from '~/components/templates/IntroSmallImage.vue';
import IntroWithoutImage from '~/components/templates/IntroWithoutImage.vue';
import WithoutIntroLargeImage from '~/components/templates/WithoutIntroLargeImage.vue';

definePageMeta({
  auth: false,
  middleware: ['sofie-page'],
});

const currentPage = useSofiePage();

const template = computed(() => {
  const templateName = currentPage.value?.template?.__typename;

  if (templateName === 'TemplateStandaard') {
    return Default;
  }

  if (templateName === 'TemplateIntroimage') {
    return IntroImage;
  }

  if (templateName === 'TemplateIntrosmallimage') {
    return IntroSmallImage;
  }

  if (templateName === 'TemplateIntrowithoutimage') {
    return IntroWithoutImage;
  }

  if (templateName === 'TemplateWithoutintrolargeimage') {
    return WithoutIntroLargeImage;
  }

  return Default;
});
</script>
